import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationVendeur from '../../../components/vendeur/NotificationVendeur';

function VendeurNotifications() {
  const [vendeur, setVendeur] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem('vendeurConnecte');
    if (data) {
      try {
        const parsed = JSON.parse(data);
        setVendeur(parsed);
      } catch (err) {
        console.error('Erreur parsing vendeurConnecte :', err);
      }
    } else {
      navigate('/vendeur/login');
    }
  }, [navigate]);

  return (
    <div className="vendeur-notifications-page">
      {vendeur ? (
        <NotificationVendeur vendeurId={vendeur.id} />
      ) : (
        <p>Chargement...</p>
      )}
    </div>
  );
}

export default VendeurNotifications;
